import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';
import {toFormikValidationSchema} from 'zod-formik-adapter';

import {FormWithButtons} from '@flexinet/ui-components';

import {MeterAssignment} from '../types';
import {stage} from "../../../config/stage";

// channelIdentifiers is carried as a parsed object in the client model but
// edited as JSON text in the textarea. Serialize on the way into the form so the
// field shows readable JSON; the build helper re-parses on submit.
const toFormChannelIdentifiers = (value: unknown): string => {
    if (typeof value === 'string') return value;
    if (value && typeof value === 'object') return JSON.stringify(value, null, 2);
    return '{}';
};

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<MeterAssignment, 'id'>,
    handleSubmit: (values: MeterAssignment) => void,
    handleCancel?: () => void
}) => {

    const onSubmit = (values: MeterAssignment) => {

        console.debug(values)

        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {} as MeterAssignment;

    if (record) {
        initialValues = Object.assign({}, initialValues, record, {
            channelIdentifiers: toFormChannelIdentifiers(record.channelIdentifiers),
        });
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={toFormikValidationSchema(RecordSchema)}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
